/* global bz_app, $*/
bz_app.directive('photoRibbon', [
  '$rootScope',
  '$timeout',
  'urlService',
  function ($rootScope, $timeout, urlService) {
    return {
      restrict: 'AE',
      scope: {
        propertyId: '=',
        photosData: '=',
      },
      templateUrl: urlService.templateUrl('property/directives/photo_ribbon'),
      link: function (scope) {
        scope.photos = []
        scope.topPhotos = []
        scope.bottomPhotos = []

        scope.loadPhotos = function () {
          if (scope.photosData) {
            scope.loadPhotosFromInput()
          }
        }

        scope.loadPhotosFromInput = function () {
          if (scope.photosData) {
            scope.setPhotos(scope.photosData)
            $timeout(function () {
              scope.setPhotoRibbonPosition()
            }, 100)
          } else {
            $rootScope.$broadcast('property-photos-not-loaded')
          }
        }

        scope.setPhotos = function (response) {
          scope.photos = response
          scope.topPhotos = scope.photos.slice(0, 15)
          scope.bottomPhotos = scope.photos.slice(15, 30)
        }

        scope.setPhotoRibbonPosition = function () {
          $('.top-ribbon').scrollLeft(60)
          $('.bottom-ribbon').scrollLeft(168)

          $(function () {
            //lazy loading of images (http://www.appelsiini.net/projects/lazyload)
            $('.top-ribbon img.lazy-load').lazyload({ threshold: 500 })
            $('.bottom-ribbon img.lazy-load').lazyload({ threshold: 500 })
          })
        }

        scope.photoThumbnail = function (photo) {
          return urlService.imgCropUrl(photo.slug, 'square_200')
        }

        scope.photoModal = function (photo) {
          return urlService.imgCropUrl(photo.slug, 'high_1000')
        }

        scope.loadPhotos()
      },
    }
  },
])
